export default "__VITE_ASSET__62e2c8cb__"